// @flow
import Swiper from 'swiper/swiper-bundle';
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from "fg-frontend/src/lib/classNames";

const fragments = {
	SWIPER: '[data-fragment="PageTopSwiper.swiper"]',
	PAGINATION: '[data-fragment="PageTopSwiper.pagination"]',
	IMAGE: '[data-fragment="PageTopSwiper.image"]'
};

export default class PageTopSwiper extends WebComponent {

	constructor(props) {
		super(props);

		this.state = {
			activeSlideIndex: 0
		};
	}

	didMount() {
		this.swiperEl = this.element.querySelector(fragments.SWIPER);
		this.images = this.element.querySelectorAll(fragments.IMAGE);
		const options = {
			autoHeight: true,
			pagination: {
				el: this.element.querySelector(fragments.PAGINATION),
				clickable: true
			},
			autoplay: {
				delay: 5000
			},
		};
		this.swiper = new Swiper(this.swiperEl, options);
		this.swiper.on('afterInit', () => this.setImages(this.swiper.activeIndex));
		this.swiper.on('activeIndexChange', () => this.setImages(this.swiper.activeIndex));
	}

	setImages = (activeIndex) => {
		this.setState({
			activeSlideIndex: activeIndex
		})
	}

	willUnmount() {
		this.slider.destroy();
	}

	update() {
		const { activeSlideIndex } = this.state;
		for (let i = 0; i < this.images.length; i++) {
			classNames(this.images[i], { 'page-top__slide-img--active': false });
			if ( activeSlideIndex === i) {
				classNames(this.images[i], { 'page-top__slide-img--active': true });
			}
		}
	}
}


// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/PageTopSwiper.js